export const AB_TEST_STATUS_INITIAL = 'AB_TEST_STATUS_INITIAL'
export const AB_TEST_STATUS_LOADING = 'AB_TEST_STATUS_LOADING'
export const AB_TEST_STATUS_READY = 'AB_TEST_STATUS_READY'
